// extracted by mini-css-extract-plugin
export default {"root":"SearchInput_root__e8NPk","input":"SearchInput_input__5qDTZ","searchIcon":"SearchInput_searchIcon__g2dTQ"};